import React, { type FC } from "react";
import { BusinessList } from "@src/components/business-list";
import { ListItem } from "@src/components/business-list";
import { BusinessLotValue, BusinessMeasureValue, BusinessStockObjValue } from "@src/components/business-data-display";
import { OverflowMarquee } from "@src/shared/ui";
import type { UseStockPartialInventoryContentsQueryResult } from "../../hooks";
import {
    formatInventoryCells,
    isStockPartialInventoryContentInventoried,
    isStockPartialInventoryContentLotBased,
} from "../../helpers/formatStockPartialInventoryContent";

/** Пропсы компонента {@link StockPartialInventoryContentsList}. */
interface StockPartialInventoryContentsListProps {
    /** Query-result строк АПН. */
    contentsQuery: UseStockPartialInventoryContentsQueryResult;
    /**
     * Открывает форму инвентаризации строки АПН.
     * @param contentCode код строки АПН
     */
    onOpenContent: (contentCode: number) => void;
}

/** Список строк АПН для частичной инвентаризации склада. */
export const StockPartialInventoryContentsList: FC<StockPartialInventoryContentsListProps> = ({
    contentsQuery,
    onOpenContent,
}) => {
    const { content, isFetching } = contentsQuery;

    return (
        <BusinessList isLoad={isFetching} emptyText="Список строк АПН пуст">
            {content.map((item) => {
                const isLotBased = isStockPartialInventoryContentLotBased(item);
                const isInventoried = isLotBased && isStockPartialInventoryContentInventoried(item);

                return (
                    <ListItem
                        key={item.Code}
                        disabled={!isLotBased}
                        tone={isInventoried ? "success" : "default"}
                        title={<BusinessStockObjValue stockObj={item.StockObj} mode="wrap" />}
                        props={[
                            ...(isInventoried
                                ? [
                                      {
                                          label: "Факт. кол-во",
                                          value: <BusinessMeasureValue value={item.FactReminder} measure={item.Measure} />,
                                      },
                                  ]
                                : []),
                            {
                                label: "Партия",
                                value: <BusinessLotValue lot={item.Lot} fallback={isLotBased ? "—" : "Без партии"} />,
                            },
                            {
                                label: "Ячейки хранения",
                                value: <OverflowMarquee>{formatInventoryCells(item.PlacedCellRemainders)}</OverflowMarquee>,
                            },
                            {
                                label: "Партия инв-на",
                                value: isLotBased ? (isInventoried ? "Да" : "Нет") : "Недоступно",
                            },
                        ]}
                        onClick={
                            isLotBased
                                ? () => {
                                      onOpenContent(item.Code);
                                  }
                                : undefined
                        }
                    />
                );
            })}
        </BusinessList>
    );
};
